import { graphql } from '@/gql';

graphql(`
  fragment SingleOrderPartialFragment on PaginatedDeliveryOrderResponse {
    count
    rows {
      id
      callerId
      caller {
        firstName
        lastName
        phoneNumber
        isRequiredMonitoringGourmetOrder
      }
      orderId
      preferredPhoneNumber
      isRedelivery
      originalOrderId
      natureOfComplaint
      clientName
      operatorId
      operator {
        firstName
        lastName
      }
      scheduleId
      total
      service
      serviceAccount {
        email
        phoneNumber
      }
      storeOrder {
        title
        subtitle
        phoneNumber
        address {
          formattedAddress
        }
        estimate {
          total
          serviceEstimateReference
          charges {
            title
            value
            originalValue
            tooltips {
              title
              value
            }
          }
          timeEstimate {
            min
            max
          }
          chargeOptions {
            plan
            tier
            applyDiscountedFee
            noServiceFee
            doNotCharge
            chargeNow
            reason
          }
          address {
            formattedAddress
            streetAddress2
          }
          items {
            item {
              title
              price
              quantity
            }
          }
          orderOptions {
            storeInstructions
            deliveryInstructions
            dropoffOptionId
          }
        }
      }
      orderStatus {
        currentProgress
        title
        subtitle
        description
        agent {
          phoneNumber
          name
        }
        locationMarkers {
          title
          latitude
          longitude
        }
      }
      status
      paidStatus
      rateInfo {
        submittedAt
        submitById
        rateList {
          target {
            targetType
            targetId
          }
          starRating
          reviewText
          tagList {
            tagId
            tagName
          }
        }
      }
      relatedPath {
        orderResolution {
          resolvedByOrderID
          resolvedOrderID
          redeliveryByOrderId
          resolvedWithoutReorder
        }
      }
      isConfirmedMonitoringCall
      transactionId
      isNotReceivedOrder
      needLoveId
      createdAt
      updatedAt
    }
  }
`);
